import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import PageHeader from '../../../components/ui/pageHeader/PageHeader'
import { Tabs } from '../../../components/tabs/Tabs'
import { AccountActionList } from '../../../components/authenticated/management/audit/accountActionList/AccountActionList'
import { LoginAuditList } from '../../../components/authenticated/management/audit/loginAuditList/LoginAuditList'

export enum AuditView {
  ACCOUNT_ACTIONS = 'account-actions',
  SIGN_INS = 'sign-ins',
}

/** One place for the audit trails: actions taken on accounts and sign-in attempts (view kept in the URL). */
export const AdminAudit = () => {
  const { t } = useTranslation('audit')
  const [params, setParams] = useSearchParams()
  const view = params.get('view') === AuditView.SIGN_INS ? AuditView.SIGN_INS : AuditView.ACCOUNT_ACTIONS

  return (
    <>
      <PageHeader
        title={{
          eyebrow: t('audit.eyebrow'),
          h1: t('audit.title'),
        }}
        sub={t(view === AuditView.SIGN_INS ? 'audit.logins.subtitle' : 'audit.actions.subtitle')}
      />
      <div className="mb-4">
        <Tabs
          tab={view}
          tabs={[
            { value: AuditView.ACCOUNT_ACTIONS, label: t('audit.actions.title') },
            { value: AuditView.SIGN_INS, label: t('audit.logins.title') },
          ]}
          onChange={value => setParams({ view: value }, { replace: true })}
        />
      </div>
      {view === AuditView.SIGN_INS ? <LoginAuditList /> : <AccountActionList />}
    </>
  )
}
